var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatePersonalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 120,
    viewBox: "0 0 146 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4922_148762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.3013 98.1053H10.0859V0H96.3013V98.1053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3013 98.1053H10.0859V0H96.3013V98.1053ZM11.3491 96.9336H95.0382V1.17169H11.3491V96.9336Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3317 0H10.2266V12.55H96.3317V0Z",
    fill: "#297DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5731 31.1589C26.6218 31.1589 29.904 27.8767 29.904 23.828C29.904 19.7792 26.6218 16.4971 22.5731 16.4971C18.5243 16.4971 15.2422 19.7792 15.2422 23.828C15.2422 27.8767 18.5243 31.1589 22.5731 31.1589Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9087 18.6533H35.7969V20.8095H60.9087V18.6533Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.138 23.8271H35.7969V25.9833H91.138V23.8271Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.138 29.0029H35.7969V31.1591H91.138V29.0029Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5731 91.1648C26.6218 91.1648 29.904 87.8826 29.904 83.8338C29.904 79.7851 26.6218 76.5029 22.5731 76.5029C18.5243 76.5029 15.2422 79.7851 15.2422 83.8338C15.2422 87.8826 18.5243 91.1648 22.5731 91.1648Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9087 78.6592H35.7969V80.8153H60.9087V78.6592Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.138 83.834H35.7969V85.9901H91.138V83.834Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.138 89.0078H35.7969V91.164H91.138V89.0078Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7917 3.20605H12.8672V4.78723H23.7917V3.20605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7917 5.9375H12.8672V7.51868H23.7917V5.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7917 8.66895H12.8672V10.2501H23.7917V8.66895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.551 67.781H0.828125V39.8809H105.551V67.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.551 67.781H0.828125V39.8809H105.551V67.781ZM2.09128 66.5179H104.288V41.144H2.09128V66.5179Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.826 61.0387C17.8289 61.0387 21.0738 57.7937 21.0738 53.7908C21.0738 49.7879 17.8289 46.543 13.826 46.543C9.8231 46.543 6.57812 49.7879 6.57812 53.7908C6.57812 57.7937 9.8231 61.0387 13.826 61.0387Z",
    fill: "#297DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0175 47.6797H29.0312V49.8114H59.0175V47.6797Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1146 52.7949H29.0312V54.9266H95.1146V52.7949Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1146 57.9111H29.0312V60.0429H95.1146V57.9111Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.31 75.1344C122.402 75.0976 122.497 75.0682 122.594 75.0463L125.792 66.7386L124.435 65.0546L126.709 62.6748C127.365 63.6416 130.615 65.6785 129.626 67.1309L124.664 75.9594C124.803 76.2082 124.884 76.4854 124.9 76.7701C124.917 77.0547 124.869 77.3394 124.759 77.6027C124.65 77.8661 124.483 78.1012 124.269 78.2905C124.056 78.4797 123.803 78.6182 123.528 78.6954C121.313 79.3595 120.154 75.9511 122.31 75.1344Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.327 66.7041C124.754 66.8695 122.587 63.501 122.225 63.208C121.794 62.7999 121.542 62.2373 121.524 61.6437C121.507 61.0501 121.726 60.4738 122.133 60.0412C122.54 59.6086 123.102 59.3551 123.695 59.3361C124.289 59.3172 124.866 59.5344 125.299 59.9401L128.631 62.2724C128.726 62.3395 128.805 62.426 128.863 62.5261C128.921 62.6262 128.957 62.7376 128.969 62.8528C128.981 62.968 128.968 63.0844 128.931 63.1942C128.894 63.3039 128.834 63.4045 128.755 63.4892C128.356 63.7602 125.893 66.9109 125.327 66.7041Z",
    fill: "#297DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.467 117.24L123.886 117.24L123.5 107.284L126.467 107.284L126.467 117.24Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12 119.741L118.798 119.741C118.72 115.336 124.349 116.537 127.12 116.396L127.12 119.741Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.868 116.39L132.305 116.687L129.938 106.94L133.721 106.501L134.868 116.39Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.816 118.799L127.549 119.758C126.964 115.391 132.695 115.935 135.431 115.477L135.816 118.799Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.925 114.877H122.681V98.8812L120.203 85.5278L116.812 73.6631L124.766 69.7939L126.282 72.177C126.517 72.3908 130.317 75.9069 130.727 79.391C131.144 82.9422 127.109 113.487 126.937 114.786L126.925 114.877Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.098 76.147L115.788 70.4041C115.481 70.1086 112.573 67.1276 115.791 63.318L117.488 58.8957L122.457 57.3564L124.4 58.8606C125.182 59.4656 125.804 60.2536 126.21 61.1554C126.617 62.0573 126.795 63.0451 126.73 64.0321L126.2 72.1571L117.098 76.147Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.357 47.8316C126.478 50.7455 122.274 58.4337 117.058 55.696C111.938 52.7822 116.141 45.094 121.357 47.8316Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.269 58.1897C107.286 58.2964 107.294 58.4042 107.293 58.5122L115.304 63.9376L117.42 62.9146L119.381 65.9064C118.196 66.3644 115.241 69.3049 113.947 67.9012L105.818 60.4792C105.52 60.5654 105.207 60.583 104.902 60.5307C104.596 60.4783 104.307 60.3574 104.055 60.1771C103.803 59.9967 103.595 59.7615 103.447 59.4893C103.299 59.217 103.214 58.9148 103.2 58.6052C103.041 56.0968 106.934 55.707 107.269 58.1897Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.454 63.4642C115.42 62.8164 119.518 61.3499 119.917 61.0386C120.455 60.682 121.113 60.5534 121.746 60.6808C122.378 60.8083 122.935 61.1814 123.293 61.7184C123.651 62.2555 123.781 62.9126 123.656 63.5457C123.53 64.1788 123.158 64.7362 122.622 65.0958L119.335 68.0508C119.241 68.1343 119.13 68.1967 119.009 68.2338C118.889 68.2709 118.762 68.2818 118.637 68.2659C118.513 68.25 118.393 68.2075 118.285 68.1415C118.178 68.0754 118.087 67.9872 118.016 67.8827C117.827 67.3943 115.096 64.013 115.454 63.4642Z",
    fill: "#297DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.321 111.705L125.055 98.5124L128.563 93.4688L136.276 111.251L130.321 111.705Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.963 120H110.226C110.17 120 110.117 119.978 110.077 119.938C110.038 119.899 110.016 119.845 110.016 119.79C110.016 119.734 110.038 119.68 110.077 119.641C110.117 119.601 110.17 119.579 110.226 119.579H144.963C145.019 119.579 145.072 119.601 145.112 119.641C145.151 119.68 145.173 119.734 145.173 119.79C145.173 119.845 145.151 119.899 145.112 119.938C145.072 119.978 145.019 120 144.963 120Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.089 51.6594C133.378 51.9749 131.588 51.4532 130.122 50.5166C128.657 49.58 127.479 48.2561 126.434 46.8656C125.845 46.0828 125.276 45.2571 124.475 44.6938C123.674 44.1304 122.566 43.8805 121.711 44.3569C120.957 44.7768 120.624 45.8791 121.067 46.569C119.879 46.2712 118.619 46.3608 117.418 46.6148C116.261 46.8596 115.085 47.2819 114.285 48.1521C113.484 49.0224 113.181 50.4363 113.858 51.4061L114.862 51.5792C116.694 51.1612 117.541 51.3468 119.374 51.7649C119.312 51.4407 119.821 51.2682 120.078 51.4748C120.336 51.6814 120.243 52.0923 120.409 52.3773C121.117 53.5917 121.118 55.0819 120.756 56.2108C122.572 55.4567 123.903 53.4153 124.275 51.4847C124.458 50.6415 124.391 49.763 124.08 48.958C123.93 48.6055 123.725 48.2792 123.472 47.9916C124.153 48.1913 124.781 48.5391 125.311 49.0101C126.246 49.8233 126.922 50.8847 127.669 51.8729C128.417 52.8612 129.289 53.8188 130.438 54.2841C132.199 54.9977 134.29 54.3736 135.736 53.1406C136.864 52.1784 137.661 50.9031 138.296 49.5526C137.93 50.1009 137.457 50.5699 136.906 50.9319C136.355 51.2938 135.737 51.5412 135.089 51.6594Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.297 49.5523C138.526 49.1979 138.695 48.8085 138.799 48.3994C138.642 48.7863 138.476 49.1721 138.297 49.5523Z",
    fill: "#2F2E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4922_148762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.342,
    height: 120,
    fill: "white",
    transform: "translate(0.828125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePersonalIcon);
export default __webpack_public_path__ + "static/media/update-personal-icon.afd781f065899c41e3e41732d2edaf29.svg";
export { ForwardRef as ReactComponent };